import {Component, OnInit} from 'ng-metadata/core';
import {CitationLinkerService} from './citationLinker.service';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {FormBuilderEnums} from '../infra/formBuilder/formBuilder.service';
import {getVid} from '../appConfig/appConfigForward';
import {getCitationLinkerBaseURL} from '../appConfig/appConfigForward';
import {PrimolyticsService,beacon} from '../analytics/primolytics.service';
import {Inject} from 'ng-metadata/core';
import {getInstitutionCode, isNgrs} from '../appConfig/appConfigForward';
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";
import {MediaQueries} from "../infra/mediaQueries.service";
import {isBrowserIE} from "../infra/browserSniffer";
const sortBy = require('lodash/sortBy');
const has = require('lodash/has');
const indexOf = require('lodash/indexOf');
const includes = require('lodash/includes');
const intersection = require('lodash/intersection');


@Component({
    selector: 'prm-citation-linker',
    templateUrl: 'components/citationLinker/citation-linker.html',
})

export class PrmCitationLinker implements OnInit{
        
    private tabs: string[] = [TAB.ARTICLE, TAB.BOOK, TAB.JOURNAL];
    private activeTab : string = TAB.ARTICLE;
    private sortedOpenURLFields: Object[];
    private articleFields: Object[];
    private bookFields: Object[];
    private journalFields: Object[];
    private vid: string = getVid();
    private baseURL: string = getCitationLinkerBaseURL();
    private institution_code: string = getInstitutionCode();
    private journalTitleDropdown:string[] = ['contains','exact','startswith'];
    private titleSearch: string;
    private openURLFields: Object = {};
    private formData: Object = {};
    private isJtitle: boolean;
    private isDoi: boolean;
    private isPmid: boolean;
    private isDate: boolean;
    private isIe = isBrowserIE();
    
    private articleMappingFields = [["atitle", "jtitle"], ["date"], ["volume", "issue"], ["spage", "epage"], ["issn", "doi", "pmid"], ["aulast", "aufirst", "auinit"], ["publisher", "pubdate"]];
    private bookMappingFields= [["btitle"], ["date"], ["volume", "part"], ["isbn"], ["aulast","aufirst", "auinit"], ["publisher", "pubdate"]];
    private journalMappingFields = [["jtitle"], ["date"], ["volume", "issue"], ["issn", "doi"]];
    
    constructor(private citationLinkerService: CitationLinkerService, private mappingTablesCache: MappingTablesCache, private primolyticsService: PrimolyticsService,
                 @Inject('$sce') private $sce: ng.ISCEService,
                 private configurationUtil: ConfigurationUtil,
                private mediaQueries: MediaQueries) {
        this.sortedOpenURLFields = this.initOpenURLFields(TAB.ARTICLE, this.articleMappingFields);
        this.initTitleSearch();
        this.callBeacon();
    }
    

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }




    
    @beacon({'p':'citation-linker','op':'citationLinkerClick'})
    private callBeacon() {}
   
    
    private initTitleSearch() {
        if (this.isSfx()) {
            this.titleSearch = 'contains';   
        }
        else {
            this.titleSearch = 'exact'; 
        }  
    }
    
    
    private initOpenURLFields(tab:TAB, openURLArray) {
        let openURLFieldsDisplay;
        let tabFields;
        let openURLFields= this.mappingTablesCache.findByProperties('Citation Linker Definitions', {target: 'Yes', source3: this.vid, source1: tab});
        if (openURLFields.length === 0){ 
            openURLFields= this.mappingTablesCache.findByProperties('Citation Linker Definitions', {target: 'Yes', source3: 'default', source1: tab});
        }
        if (openURLFields.length > 0){     
            tabFields =  openURLFields.map((field) => {return field.source2}); 
            openURLFieldsDisplay = openURLArray.map((element) => {return intersection(element,tabFields)});
            openURLFieldsDisplay = openURLFieldsDisplay.map((field) => field.map((f) => {return {name: 'rft.' + f, label: (f === 'date') ? 'nui.citationLinker.'+ f 
                                                : 'citationLinker.'+ f, uiType: (f === 'date') ?  FormBuilderEnums.UI_TYPE.DATE_DROPDOWN : FormBuilderEnums.UI_TYPE.TEXT}}));
            this.isJtitle = this.isParamInDisplay(tabFields, 'jtitle');
            this.isDoi = this.isParamInDisplay(tabFields, 'doi');
            this.isPmid = this.isParamInDisplay(tabFields, 'pmid'); 
            this.isDate = this.isParamInDisplay(tabFields, 'date');         
        }
        return openURLFieldsDisplay;
    }
    
   private isParamInDisplay(tabFields, param) {
       if (indexOf(tabFields, param) !== -1) {
            return true;
       }
       return false;
   }
    
   public changeTab() {
       let openURLArray;
       if (this.activeTab === TAB.ARTICLE) {
           openURLArray = this.articleMappingFields;
       }
       else if (this.activeTab === TAB.BOOK) {
           openURLArray = this.bookMappingFields;
               
        }
        else if (this.activeTab === TAB.JOURNAL) {
            openURLArray = this.journalMappingFields;
        }        
       this.sortedOpenURLFields = this.initOpenURLFields(this.activeTab, openURLArray);
       this.clearForm();
   }
    
    
    public clearForm() {
        this.formData = {};
        this.initTitleSearch();
    }
    
    private isSfx() {
        if (this.baseURL !== 'ALMA_OPENURL') {
            return true;
        }    
        return false;
    }
    
    private isRapido() {
        return isNgrs();
    }
    
    
    public getBaseURL() {
        if(this.configurationUtil.isSuprima()){
            return '/discovery/openurl';
        }
        if (this.baseURL === 'ALMA_OPENURL') {
            return '/openurl/' + this.institution_code + "/" + this.vid;
        } 
        return this.$sce.trustAsResourceUrl(this.baseURL);        
    }
    
    public getTitleSearch() {
       if (this.titleSearch === 'startswith') {
            return 'begins';   
       }
        return this.titleSearch;
    }   

    public isOpenURLFieldFilled(field: string): boolean {
        if (has(this.formData, field) && this.formData[field].length > 0) {
            return true;
        }
        return false;
    }


    public calcDate(){
        let date = '';
        if (this.formData.hasOwnProperty('rft.date') && this.formData['rft.date'].year) {
            date = this.formData['rft.date'].year;
            if (this.formData['rft.date'].month) {
                date = date + '-' + this.formData['rft.date'].month;
                if (this.formData['rft.date'].day) {
                    date = date + '-' + this.formData['rft.date'].day;
                }
             }
        }
        return date;
    }
    public isSuprima(){
        return this.configurationUtil.isSuprima();
    }
    get viewCode(){
        return this.vid;
    }
    get institutionCode(){
        return this.institution_code;
    }
     
}

enum TAB{
    ARTICLE = 'article',
    BOOK = 'book',
    JOURNAL = 'journal'
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/citationLinker/citationLinker.directive.ts